var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.current_role_user == 5)?_c('contenidodocente'):_vm._e(),(_vm.current_role_user != 5 && _vm.current_role_user > 0)?_c('contenidoalumno'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }